import React, { Component } from 'react';
import ItemWithUtil from './ItemWithUtil';
import { connect } from 'react-redux';
import { formatPrice } from 'utils';
import { removeProductFromCart } from './actions';

class ItemMinicart extends Component {
    handleRemoveFromCartClick = event => {
        let { cartItemId } =
            event.currentTarget.dataset || event.srcElement.dataset;
        this.props.removeProductFromCart(this.props.cartId, cartItemId);
    };

    render() {
        const { product, formClassName } = this.props;

        return (
            <div>
                {product.qty} x {formatPrice(product.price)}
                <button
                    className={formClassName('button')}
                    data-cart-item-id={product.item_id}
                    onClick={this.handleRemoveFromCartClick}
                >
                    <i className="fas fa-times-circle" />
                </button>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { cartId } = state.cartReducer;

    return {
        cartId: cartId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        removeProductFromCart: (cartId, productSku) =>
            dispatch(removeProductFromCart(cartId, productSku))
    };
};

export default ItemWithUtil(
    connect(mapStateToProps, mapDispatchToProps)(ItemMinicart),
    'cartList'
);



// WEBPACK FOOTER //
// ./src/components/ProductItem/ItemMinicart.jsx